// extracted by mini-css-extract-plugin
export default {"Container":"PostMediaPreview_Container__TPP6H"};